import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import css from './DisciplinesLevelMapper.css';
import { LevelInfo } from '../../components';
import {
    commonDisciplines,
    EXPERIENCE_LEVEL_ADVANCED,
    EXPERIENCE_LEVEL_BEGINNER,
    EXPERIENCE_LEVEL_EXPERIENCED,
    EXPERIENCE_LEVEL_VERY_EXPERIENCED,
} from '../../marketplace-custom-config';

const DisciplinesLevelMapper = ({
    level,
    user,
    discipline: disciplineId,
    placeholderClassName = '',
    containerRef,
    levelInfoRootClassName,
}) => {
    const {
        attributes: {
            profile: {
                publicData: { userType },
            },
        },
    } = user;

    const levelMapper = {
        1: EXPERIENCE_LEVEL_BEGINNER,
        2: EXPERIENCE_LEVEL_ADVANCED,
        3: EXPERIENCE_LEVEL_EXPERIENCED,
        4: EXPERIENCE_LEVEL_VERY_EXPERIENCED,
    };

    const levelInfoMaybe = typeof level === 'number';
    const discipline = commonDisciplines.find(({ id }) => id === disciplineId);

    return levelInfoMaybe ? (
        <div className={css.levelsSection}>
            <LevelInfo
                containerRef={containerRef}
                name={level}
                disciplineLabel={discipline ? discipline.label : 'custom'}
                values={levelMapper}
                userType={userType}
                levelInfoRootClassName={levelInfoRootClassName}
            />
        </div>
    ) : (
        <div className={placeholderClassName}>
            <FormattedMessage id="ProfileSettingsForm.editItemNoItem-userDisciplines" />
        </div>
    );
};

export default DisciplinesLevelMapper;
